module.exports = __webpack_public_path__ + "static/media/Medical Evacuation.273a7562.png";